import { auth } from "@/config/firebase";
import { setCurrentUser } from "@/utils/helpers";
import { log } from "@/utils/logger";
import { useEffect, useRef } from "react";

const useCheckEmailStatus = ({ check }: { check: boolean }) => {
    const interval = useRef<NodeJS.Timeout>();

    const checkEmailStatus = async () => {
        try {
            const user = auth.currentUser;
            if (!user) return;

            await user.reload();
            if (!user.emailVerified) return;

            await setCurrentUser(user);
        } catch (e) {
            log.error(e, "checkEmailStatus");
        }
    };

    useEffect(() => {
        if (!check) return;

        if (interval.current) {
            clearInterval(interval.current);
        }

        interval.current = setInterval(checkEmailStatus, 10000);
        window.addEventListener("focus", checkEmailStatus);
        window.addEventListener("blur", checkEmailStatus);

        return () => {
            window.removeEventListener("focus", checkEmailStatus);
            window.removeEventListener("blur", checkEmailStatus);

            interval.current && clearInterval(interval.current);
        };
    }, [check]);
};

export default useCheckEmailStatus;
